import { Link } from "react-router-dom";
import { BookOpen, ArrowRight } from "lucide-react";
import { useSeo } from "@/hooks/useSeo";
import BreadcrumbJsonLd from "@/components/BreadcrumbJsonLd";
import { GUIDES } from "@/data/guides";

export default function Guides() {
  useSeo({
    title: "Guides & conseils locaux — visibilité, mini-site, associations | PROXIreduc-28",
    description:
      "Nos guides pratiques pour les professionnels, commerçants et associations d'Eure-et-Loir : mini-site, carte de visite digitale, référencement local sur Google et visibilité associative.",
    canonicalPath: "/guides",
    image: "/og-image.jpg",
  });

  return (
    <div className="bg-[#FAF8F5] min-h-screen" data-testid="guides-page">
      <BreadcrumbJsonLd items={[{ name: "Accueil", path: "/" }, { name: "Guides" }]} />
      <section className="bg-gradient-to-br from-slate-900 via-slate-800 to-[#E05638] text-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-20">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/15 text-[10px] font-bold uppercase tracking-widest">
            <BookOpen size={12} /> Guides & conseils
          </div>
          <h1 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight">
            Guides pratiques pour la vie locale en <span className="text-emerald-300">Eure-et-Loir</span>
          </h1>
          <p className="mt-4 text-white/85 text-base md:text-lg max-w-2xl">
            Des conseils concrets pour gagner en visibilité, créer votre mini-site, votre carte de visite digitale ou faire connaître votre association sur le territoire.
          </p>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {GUIDES.map((g) => (
            <Link
              key={g.slug}
              to={`/guides/${g.slug}`}
              className="bg-white border border-slate-200 rounded-2xl p-6 flex flex-col card-hover"
              data-testid={`guide-card-${g.slug}`}
            >
              <span className="text-[11px] font-bold uppercase tracking-wide text-[#E05638]">{g.category}</span>
              <h2 className="mt-2 font-heading text-lg font-extrabold text-slate-900">{g.title}</h2>
              <p className="mt-2 text-sm text-slate-600 flex-1">{g.excerpt}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-slate-900">
                Lire le guide <ArrowRight size={15} />
              </span>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
